import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route, withRouter } from "react-router-dom";
import withAnalytics, { initAnalytics } from 'react-with-analytics';

import '../css/App.css'

import ScrollToTop from '../components/ScrollToTop';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Home from './home/Home';
import Agence from './agence/Agence';
import Methode from './methode/Methode';
import Projets from './projet/Projets';
import FicheProjet from './projet/FicheProjet';
import Mentions from './mentions/Mentions';


const Root = () => (
        <div>
          <div>
              <ScrollToTop />
              <Header />
              <Switch>
                <Route exact path="/" component={Home} />
                <Route path="/agence" component={Agence} />
                <Route path="/methode" component={Methode} />
                <Route path="/projets" component={Projets} />
                <Route path="/projet/:name" component={FicheProjet} />
                <Route path="/mentions" component={Mentions} />
              </Switch>
              <Footer />
          </div>
        </div>
);

const AppWithRouter = withRouter(withAnalytics(Root));


class App extends Component {
    constructor(props) {
        super(props);

        initAnalytics('UA-18358842-1');
    }

  render() {
    return (
        <Router>
            <AppWithRouter />
        </Router>
    );
  }

  componentDidMount () {
    const jquery = document.createElement("script");
    jquery.src = 'https://ajax.googleapis.com/ajax/libs/jquery/2.2.0/jquery.min.js';
    jquery.async = true;
    document.body.appendChild(jquery);
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/views/App.js